import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import t from './productCosting.types';
import {
  addCommentService,
  addProductCostingDataService,
  clearAllProductCostingSuggestedHighlightsService,
  copyProductCostingDocService,
  deleteProductCostingService,
  fetchExchangeRateArrService,
  fetchProductColourwaysService,
  fetchProductCostingCommentsService,
  fetchProductLengthsService,
  fetchProductSizesService,
  fetchSupplierDetailsService,
  getBomForProductTesting,
  getcompletionDetails,
  getCostingStatsService,
  getProductCostingDetailByIdService,
  getProductCostingListService,
  getUnIntegratedSupplierColouways as getUnIntegratedSupplierColouwaysService,
  getUnIntegratedSupplierCostingDetailsById as getUnIntegratedSupplierCostingDetailsByIdService,
  getUnIntegratedSupplierCostingStage as getUnIntegratedSupplierCostingStageService,
  getUnIntegratedSupplierUnits as getUnIntegratedSupplierUnitsService,
  inviteSupplierService,
  postPermissions,
  saveMultiCostingComment as saveMultiCostingCommentService,
  setDefaultProductService,
  updateCurrencyinSupplierOverviewService,
  updateProductCostingCommentService,
  updateProductCostingDataService,
} from '../../../../services/product-costing.service';
import { getCostingTemplateDetailColSizeLenByIdsService } from '../../../../services/costing-template.service';
import { ERROR_MESSAGE } from '../../../../Components/helper';
import type {
  ApiErrorData,
  ApiResponse,
  BomComponent,
  CostingComment,
  CostingRecord,
  CostingStats,
  CostingTemplateDetail,
  ExchangeRateLookupParams,
  NamedRef,
  ProductColour,
  ProductCostingDetail,
  ProductCostingFilterValues,
  ProductCostingListParams,
  ProductCostingThunkAction,
  ProductUnit,
  TransactionMsg,
} from './productCosting.types';
import { getProductDimensionService, saveProductDimensionService } from '../../../../services/product-dimension.service';
import type { ProductDimensionDto, ProductDimensionErrorDto, ProductDimensionInputDto } from '../../../../services/product-dimension.service';
import { getAutomatedFreightService } from '../../../../services/automated-freight.service';
import type { AutomatedFreightDto } from '../../../../services/automated-freight.service';

/**
 * Narrows an unknown catch variable to a display string. Replaces the JavaScript's
 * `err.toString()`, which is not valid under useUnknownInCatchVariables.
 */
const toMessage = (err: unknown): string => (err instanceof Error ? err.message : String(err));

/** Reads the `errMsg` an API error envelope carries, without asserting the envelope's shape. */
const errMsgOf = (res: ApiResponse<unknown> | undefined): string | undefined => (res?.data as ApiErrorData | undefined)?.errMsg;

export const bomProductTesting =
  (params: { devOrderId?: string | undefined }): ProductCostingThunkAction<Promise<BomComponent[] | false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await getBomForProductTesting(params)) as ApiResponse<BomComponent[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_GET_TESTING_BOM_LIST,
          payload: res.data as BomComponent[],
        });
        return res.data;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(err);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const getPermission =
  (params: unknown): ProductCostingThunkAction<Promise<boolean | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await getcompletionDetails(params)) as ApiResponse<unknown>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_MAEK_AS_COMPLETE,
          payload: res.data,
        });
      } else {
        toasterMsg(String(errMsgOf(res)), 'danger');
      }
      return true;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const addPermissions =
  (id: string, data: unknown, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<boolean | undefined>> =>
  async () => {
    try {
      const res = (await postPermissions(id, data)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        const msg = transactionMsg(`${res.message}`);
        toasterMsg(msg, 'success');
      } else {
        const msg = transactionMsg(`${res.data?.errMsg}`);
        toasterMsg(msg, 'danger');
      }
      return true;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const addProductCostingData =
  (params: unknown, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<ProductCostingDetail | false | undefined>> =>
  async () => {
    try {
      const res = (await addProductCostingDataService(params)) as ApiResponse<{ doc?: ProductCostingDetail }>;
      if (res?.code === 200) {
        toasterMsg(transactionMsg(`CONFIRMATION_POPUP_VIEW.PRODUCT_COSTING.${res?.message}`), 'success');
        return res.data?.doc;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(transactionMsg(String(errMsgOf(res))), 'danger');
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const getProductCostingList =
  (params: ProductCostingListParams): ProductCostingThunkAction<Promise<boolean>> =>
  async (dispatch) => {
    try {
      const res = (await getProductCostingListService(params)) as ApiResponse<{
        doc?: CostingRecord[];
        totalCount?: number;
        expandedStats?: CostingStats;
      }>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_LIST_PRODUCT_COSTING,
          payload: {
            data: res.data?.doc as CostingRecord[],
            totalCount: res.data?.totalCount as number,
            searchText: params.searchText,
            isScrolled: params.isScrolled,
            averageTotalCal: res?.data?.expandedStats,
          },
        });
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
      if (res.code === 401 && errMsgOf(res)) {
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
  };

export const getCostingStats =
  (params: ProductCostingListParams | undefined): ProductCostingThunkAction<Promise<CostingStats | null>> =>
  async (dispatch) => {
    try {
      /* pageIndex/pageSize are stripped deliberately — the stats endpoint aggregates over the
         whole filtered set, not the current page. */
      const { pageIndex, pageSize, ...statsParams } = params ?? {};
      const res = (await getCostingStatsService(statsParams)) as ApiResponse<CostingStats>;
      if (res?.code === 200 && res?.data != null) {
        await dispatch({
          type: t.COSTING_SET_COSTING_STATS,
          payload: res.data,
        });
        return res.data;
      }
      return null;
    } catch (err) {
      toasterMsg(toMessage(err) ?? 'Failed to load costing stats', 'danger');
      return null;
    }
  };

export const deleteProductCosting =
  (deleteId: string[], devOrderId: string, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<boolean>> =>
  async (dispatch) => {
    try {
      const body = { productIds: deleteId, devOrderId };
      const res = (await deleteProductCostingService(body)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_REMOVE_PRODUCT_COSTING,
          payload: deleteId,
        });
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.DELETED_SUCCESSFULLY'), 'success');
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
  };

export const getProductCostingDetailsById =
  (id: string | undefined, transactionMsg?: TransactionMsg): ProductCostingThunkAction<Promise<ProductCostingDetail | number | false>> =>
  async (dispatch) => {
    try {
      const res = (await getProductCostingDetailByIdService(id)) as ApiResponse<ProductCostingDetail>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_PRODUCT_COSTING_DETAIL_BY_ID,
          payload: res.data as ProductCostingDetail,
        });
        return res?.data as ProductCostingDetail;
      }
      if (res.code === 500 && errMsgOf(res)) {
        /* transactionMsg is optional here: clearAllProductCostingSuggestedHighlights re-dispatches
           this thunk without one. The original called it unconditionally and threw in that path. */
        toasterMsg(transactionMsg ? transactionMsg(String(errMsgOf(res))) : String(errMsgOf(res)), 'danger');
        return res.code;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
  };

export const updateProductCostingData =
  (data: unknown, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<boolean | undefined>> =>
  async () => {
    try {
      const res = (await updateProductCostingDataService(data)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.UPDATED_SUCCESSFULLY'), 'success');
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(transactionMsg(`${errMsgOf(res)}`), 'danger');
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const unMount = (): ProductCostingThunkAction<Promise<void>> => async (dispatch) => {
  try {
    await dispatch({
      type: t.COSTING_PRODUCT_COSTING_UNMOUNT,
    });
  } catch (err) {
    console.log(toMessage(err));
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const copyProductCostingDoc =
  (id: string, devOrderId: string, activeCostingTemplate: string | null, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<boolean>> =>
  async (dispatch) => {
    try {
      const res = (await copyProductCostingDocService(id)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        const params = {
          pageIndex: 1,
          pageSize: 20,
          devOrderId,
          costingTemplateId: activeCostingTemplate,
        };
        await dispatch(getProductCostingList(params));
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.COPIED_DOCS_SUCCESS'), 'success');
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
  };

export const inviteSupplierAction =
  (data: unknown, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<unknown>> =>
  async () => {
    try {
      const res = (await inviteSupplierService(data)) as ApiResponse<{ data?: unknown; errMsg?: string }>;
      if (res?.code === 200) {
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.INVITED_SUCCESSFULLY'), 'success');
        return res.data?.data;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return res.code;
      }
      return res?.data;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const setPreviousProductCostingData =
  (data: ProductCostingDetail): ProductCostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.COSTING_DUPLICATE_PRODUCT_COSTING_DETAIL,
        payload: data,
      });
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };

export const selectAllProduct =
  (ids: string[]): ProductCostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.COSTING_SELECT_ALL_PRODUCT,
        payload: ids,
      });
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };

/**
 * Clears every supplier-suggested highlight on a costing, then reloads the document.
 *
 * `transactionMsg` is forwarded to the reload so a failure there can be reported in the user's
 * language. The original omitted it, which made the reload's 500 branch throw — see C1 in
 * IMPLEMENTATION_NOTES-ProductCostingTSX.md.
 */
export const clearAllProductCostingSuggestedHighlights =
  (id: string, keys: unknown, transactionMsg?: TransactionMsg): ProductCostingThunkAction<Promise<boolean | number | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await clearAllProductCostingSuggestedHighlightsService(id, keys)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        await dispatch(getProductCostingDetailsById(id, transactionMsg));
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return res.code;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
    return undefined;
  };

export const addComment =
  (data: { costingId: string; [key: string]: unknown }, renderList: boolean, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<number | false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await addCommentService(data)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.COMMENT_ADDED'), 'success');

        if (renderList) {
          await dispatch(fetchProductCostingComments(data.costingId));
        }
        return res.code;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const fetchProductCostingComments =
  (costingId: string): ProductCostingThunkAction<Promise<boolean | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await fetchProductCostingCommentsService(costingId)) as ApiResponse<{ doc?: CostingComment[] }>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_LIST_PRODUCT_COSTING_COMMENT,
          payload: res.data?.doc as CostingComment[],
        });
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const editCommentAction =
  (data: CostingComment): ProductCostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.COSTING_SET_DATA_TO_UPDATE_COMMENT,
        payload: data,
      });
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };

export const updateComment =
  (data: { costingId: string; [key: string]: unknown }, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<boolean | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await updateProductCostingCommentService(data)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        dispatch(fetchProductCostingComments(data.costingId));
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.COMMENT_UPDATED'), 'success');
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const fetchProductColourways =
  (id: string): ProductCostingThunkAction<Promise<ProductColour[] | false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await fetchProductColourwaysService(id)) as ApiResponse<ProductColour[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_PRODUCT_COLOUR,
          payload: res?.data as ProductColour[],
        });

        return res.data;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const fetchProductLengths =
  (id: string): ProductCostingThunkAction<Promise<string[] | false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await fetchProductLengthsService(id)) as ApiResponse<string[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_PRODUCT_LENGTHS,
          payload: res?.data as string[],
        });

        return res?.data;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const fetchProductSizes =
  (id: string): ProductCostingThunkAction<Promise<string[] | false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await fetchProductSizesService(id)) as ApiResponse<string[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_PRODUCT_SIZES,
          payload: res?.data as string[],
        });
        return res?.data;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const filterSortData =
  (obj: Partial<ProductCostingFilterValues>): ProductCostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.COSTING_SET_FILTER_SORT_DATA,
        payload: obj,
      });
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };

export const getUnIntegratedSupplierColouways =
  (obj: unknown): ProductCostingThunkAction<Promise<false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await getUnIntegratedSupplierColouwaysService(obj)) as ApiResponse<ProductColour[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_UNINTEGRATED_COLOURWAYS,
          payload: res?.data as ProductColour[],
        });
      } else if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const getUnIntegratedSupplierUnits =
  (obj: unknown): ProductCostingThunkAction<Promise<false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await getUnIntegratedSupplierUnitsService(obj)) as ApiResponse<ProductUnit[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_UNINTEGRATED_UNITS,
          payload: res?.data as ProductUnit[],
        });
      } else if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const getUnIntegratedSupplierCostingDetailsById =
  (obj: unknown): ProductCostingThunkAction<Promise<ProductCostingDetail | number | false>> =>
  async (dispatch) => {
    try {
      const res = (await getUnIntegratedSupplierCostingDetailsByIdService(obj)) as ApiResponse<ProductCostingDetail>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_UNINTEGRATED_PRODUCT_COSTING_DETAILS,
          payload: res.data as ProductCostingDetail,
        });
        return res?.data as ProductCostingDetail;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
      if (res.code === 400 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return res.code;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
  };

export const clearedAllStatus =
  (value: boolean): ProductCostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.COSTING_SET_CLEARED_HIGHLIGHTS_STATUS,
        payload: value,
      });
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };

export const refreshModule =
  (value: boolean): ProductCostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.COSTING_SET_REFRESHED_STATE,
        payload: value,
      });
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };

export const fetchSupplierDetails =
  (supplierId: string): ProductCostingThunkAction<Promise<unknown>> =>
  async () => {
    try {
      return await fetchSupplierDetailsService(supplierId);
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const fetchExchangeRateArr =
  (obj: ExchangeRateLookupParams): ProductCostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = (await fetchExchangeRateArrService(obj)) as ApiResponse<unknown>;

      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_PRODUCT_COSTING_EXCHANGE_RATE,
          payload: res?.data,
        });
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };

/**
 * Pushes the chosen currency onto the supplier's record for this tenant.
 *
 * Surfaces the failure case. The endpoint answers 200 only when a company entry was actually
 * written; a miss now comes back as a 400 envelope carrying the reason, which has to be shown —
 * previously any miss passed silently and the screen still reported success, so the currency
 * simply never appeared in Partner Overview with nothing to explain it (BM-9899 QA).
 * @param obj The supplier id and the currency to store against it.
 * @param transactionMsg Translator used to render the backend's message key.
 */
export const updateCurrencyinSupplierOverview =
  (obj: unknown, transactionMsg?: TransactionMsg): ProductCostingThunkAction<Promise<boolean | undefined>> =>
  async () => {
    try {
      const res = (await updateCurrencyinSupplierOverviewService(obj)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        toasterMsg('supplier currency updated', 'success');
        return true;
      }
      const errMsg = res?.data?.errMsg;
      toasterMsg(errMsg && transactionMsg ? transactionMsg(errMsg) : ERROR_MESSAGE, 'danger');
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const setDefaultProductAction =
  (id: string, devOrderId: string, activeCostingTemplate: string | null, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<boolean>> =>
  async (dispatch) => {
    try {
      const res = (await setDefaultProductService(id, devOrderId)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        const params = {
          pageIndex: 1,
          pageSize: 20,
          devOrderId,
          costingTemplateId: activeCostingTemplate,
        };
        await dispatch(getProductCostingList(params));
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.DEFAULT_ADDED'), 'success');
        return true;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
  };

export const getProductCostingTemplateDetailsByIds =
  (id: string | undefined, devOrderId: string | undefined, obj: { colourWayToggle?: boolean | undefined; sizeLengthToggle?: boolean | undefined }): ProductCostingThunkAction<Promise<CostingTemplateDetail | false>> =>
  async (dispatch) => {
    try {
      const res = (await getCostingTemplateDetailColSizeLenByIdsService(id, devOrderId, obj)) as ApiResponse<CostingTemplateDetail>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_PRODUCT_COSTING_TEMPLATE_DETAIL_BY_ID,
          payload: res.data as CostingTemplateDetail,
        });
        return res.data as CostingTemplateDetail;
      }
      return false;
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
      return false;
    }
  };

export const getUnIntegratedSupplierCostingStage =
  (obj: unknown): ProductCostingThunkAction<Promise<false | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await getUnIntegratedSupplierCostingStageService(obj)) as ApiResponse<NamedRef[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.COSTING_SET_UNINTEGRATED_COSTINGSTAGE,
          payload: res?.data as NamedRef[],
        });
      } else if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export const unmountCostingState = (): ProductCostingThunkAction<Promise<void>> => async (dispatch) => {
  try {
    await dispatch({
      type: t.COSTING_SET_UNMOUNT_STATE,
    });
  } catch (err) {
    console.log(toMessage(err));
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveMultiCostingComment =
  (data: unknown, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<number | false | undefined>> =>
  async () => {
    try {
      const res = (await saveMultiCostingCommentService(data)) as ApiResponse<ApiErrorData>;
      if (res?.code === 200) {
        toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.COMMENT_ADDED'), 'success');
        return res.code;
      }
      if (res.code === 500 && errMsgOf(res)) {
        toasterMsg(String(errMsgOf(res)), 'danger');
        return false;
      }
    } catch (err) {
      console.log(toMessage(err));
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return undefined;
  };

export interface ProductDimensionSaveResult {
  saved: ProductDimensionDto | null;
  invalidFields: string[];
}

const PRODUCT_DIMENSION_INVALID = 'PRODUCT_DIMENSION_INVALID';
const PRODUCT_DIMENSION_FORBIDDEN = 'PRODUCT_DIMENSION_FORBIDDEN';

const errorEnvelopeOf = (err: unknown): ApiResponse<ProductDimensionErrorDto> | undefined =>
  (err as { response?: { data?: ApiResponse<ProductDimensionErrorDto> } })?.response?.data;

export const fetchProductDimension =
  (devOrderId: string, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<ProductDimensionDto | null>> =>
  async () => {
    try {
      const res = await getProductDimensionService(devOrderId);
      return res?.code === 200 ? (res.data ?? null) : null;
    } catch {
      toasterMsg(transactionMsg('PRODUCT_DIMENSIONS.LOAD_ERROR'), 'danger');
      return null;
    }
  };

export const saveProductDimension =
  (devOrderId: string, body: ProductDimensionInputDto, transactionMsg: TransactionMsg): ProductCostingThunkAction<Promise<ProductDimensionSaveResult>> =>
  async () => {
    try {
      const res = await saveProductDimensionService(devOrderId, body);
      if (res?.code === 200) {
        toasterMsg(transactionMsg('PRODUCT_DIMENSIONS.SAVED'), 'success');
        return { saved: res.data as ProductDimensionDto, invalidFields: [] };
      }
    } catch (err) {
      const envelope = errorEnvelopeOf(err);
      if (envelope?.message === PRODUCT_DIMENSION_INVALID) {
        toasterMsg(transactionMsg('PRODUCT_DIMENSIONS.INVALID'), 'danger');
        return { saved: null, invalidFields: envelope.data?.invalidFields ?? [] };
      }
      if (envelope?.message === PRODUCT_DIMENSION_FORBIDDEN) {
        toasterMsg(transactionMsg('PRODUCT_DIMENSIONS.FORBIDDEN'), 'danger');
        return { saved: null, invalidFields: [] };
      }
    }
    toasterMsg(transactionMsg('PRODUCT_DIMENSIONS.SAVE_ERROR'), 'danger');
    return { saved: null, invalidFields: [] };
  };

export const fetchAutomatedFreight =
  (devOrderId: string): ProductCostingThunkAction<Promise<AutomatedFreightDto | null>> =>
  async () => {
    try {
      const res = await getAutomatedFreightService(devOrderId);
      return res?.code === 200 ? (res.data ?? null) : null;
    } catch {
      return null;
    }
  };
